import { CgProfile } from "react-icons/cg";
import { LiaWalletSolid } from "react-icons/lia";
import { VscPackage } from "react-icons/vsc";
import { SlLocationPin } from "react-icons/sl";
import { GoShieldLock } from "react-icons/go";
import { GoCrossReference } from "react-icons/go";
import { IoNotificationsOutline } from "react-icons/io5";
import { TbHelpOctagon } from "react-icons/tb";

export const NavData = [
  {
    title: "Profile",
    link: "/account",
    icon:<CgProfile style={{color:'#000', fontSize:'23px', marginRight:'15px'}} />
  },
  {
    title: "Mamapurse",
    link: "/account/mamapurse",
     icon:<LiaWalletSolid style={{color:'#000', fontSize:'23px', marginRight:'15px'}} />
  },
  {
    title: "My Orders",
    link: "/account/orders",
     icon:<VscPackage style={{color:'#000', fontSize:'23px', marginRight:'15px'}} />
  },
  {
    title: "Address",
    link: "/account/address",
     icon:<SlLocationPin style={{color:'#000', fontSize:'20px', marginRight:'15px'}} />
  },
  {
    title: "Security",
    link: "/account/security",
     icon:<GoShieldLock style={{color:'#000', fontSize:'20px', marginRight:'15px'}} />
  },
  {
    title: "Referral",
    link: "/account/referral",
     icon:<GoCrossReference style={{color:'#000', fontSize:'20px', marginRight:'15px'}} />
  },
  {
    title: "Notification",
    link: "/account/notification",
     icon:<IoNotificationsOutline style={{color:'#000', fontSize:'20px', marginRight:'15px'}} />
  },
  {
    title: "Help Center",
    link: "/account/help-center",
     icon:<TbHelpOctagon style={{color:'#000', fontSize:'20px', marginRight:'15px'}} />
  },
];
